/** @format */

import { Drawer, DrawerContent } from "../../../components/ui/Drawer";
import { abbreviationsList } from "@/src/constants/StatsCornerConstants";

export default function AbbreviationsDrawer({ isOpen, setIsDrawerOpen }) {
  return (
    <Drawer dismissible={true} open={isOpen} onOpenChange={setIsDrawerOpen}>
      <DrawerContent draggable={true} side="bottom">
        <div className="m-4">
          <div className="font-bold text-base">
            Poker Abbreviations &amp; Terms
          </div>
          <div className="scrollable-container overflow-y-auto scroll-smooth max-h-[75vh]">
            {abbreviationsList.map((item, index) => (
              <div
                key={index}
                className={`border-b [border-bottom-color:var(--color-accent)] pb-3 mt-6`}
              >
                <h3 className="text-base font-semibold mb-1">
                  {item.abbreviation}
                </h3>
                <p className="text-sm text-secondary">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
